




















































import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Form } from '../models/Form';
import { ReportElement } from '../models/Report';

@Component({
    name: 'ReportView',
    computed: mapGetters(['report', 'form']),
})
export default class ReportView extends Vue {
    async created() {
        const reportId = parseInt(this.$router.currentRoute.params.report, 10);
        const accessCode = this.$router.currentRoute.params.accessCode;

        if (accessCode) {
            this.$store.commit('setAccessCode', accessCode);

            await this.$store.dispatch('report', reportId);
        }
    }
}
